export default {
      id: "filter-usage",
      viewBox: "0 0 25 26",
      url: __webpack_public_path__ + "img/icons.df848786.svg#filter",
      toString: function () {
        return this.url;
      }
    }